import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import classRoomImg from "../../../../../assets/img/teacherDashboard/Classroom.png";
import AllStudentsTab from "./AllStudentsTab";
import RefreshButtonTable from "../../../../common/RefreshButtonTable";
import { useGetClassroomStudentsList } from "../../../../../hooks/teacher/classroom/useGetClassroomStudentsList";
import "./ClassRoomDetail.css";
import BackButton from "../../Goback/GoBack";

/**
 * ClassRoomDetail component displays classroom details with tabs for
 * All Students, Complete, and Incomplete views.
 * @param {Object} props
 * @param {"school-admin" | "teacher"} props.type - Type of 
 * @returns {JSX.Element}
 */
const ClassRoomDetail = ({ type }) => {
  const { id: classroomId } = useParams();
  const { data, meta, loading, error, getClassroomStudents } =
    useGetClassroomStudentsList();

  const [activeTab, setActiveTab] = useState("all");

  // Fetch classroom students data on mount and when tab changes
  useEffect(() => {
    if (classroomId) {
      getClassroomStudents({ classroomId, status: activeTab });
    }
  }, [classroomId, activeTab]);

  /**
   * Refresh handler for refetching classroom students data
   */
  const handleRefresh = () => {
    if (classroomId) {
      getClassroomStudents({ classroomId, status: activeTab });
    }
  };

  /** @type {import("../../../../../hooks/teacher/classroom/useGetClassroomStudentsList").StudentItem[]} */
  const students = data?.students || [];

  return (
    <div className="classroom-cnt">

      <div className="classroom-container">
        <div className="pb-0">
          <BackButton />
        </div>
        <img src={classRoomImg} className="img" alt="Classroom" />
        <h2 className="text">{data?.classroom?.name || "Classroom"}</h2>
      </div>


      {/* Tabs */}
      <div className="tabs-container">
        <button
          className={`tab-btn ${activeTab === "all" ? "active" : ""}`}
          onClick={() => setActiveTab("all")}
        >
          All Students
        </button>
        <button
          className={`tab-btn ${activeTab === "complete" ? "active" : ""}`}
          onClick={() => setActiveTab("complete")}
        >
          Complete
        </button>
        <button
          className={`tab-btn ${activeTab === "incomplete" ? "active" : ""}`}
          onClick={() => setActiveTab("incomplete")}
        >
          Incomplete
        </button>
      </div>
      <RefreshButtonTable handleRefresh={handleRefresh} loading={loading} />

      <div className="tab-content">
        <AllStudentsTab
          students={students}
          loading={loading}
          error={error}
          handleRefresh={handleRefresh}
          type={type}
        />
      </div>
    </div>
  );
};

export default ClassRoomDetail;
